import { gql } from '@apollo/client';

export const RECOMMENDATIONS_HIDE_SWATCHES_QUERY = gql`
  query RECOMMENDATIONS_HIDE_SWATCHES_QUERY {
    featureConfig {
      hideSwatchesFlags: json(key: "recommendations-hide-swatches-master-flag")
    }
    isPDPRecommendationsEnabled: featureFlag(
      key: "has-pdp-recommendations-enabled",
      defaultValue: true
    )
  }
`;
